<template>
  <div class="account-management container-style">
     <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="loadingTable"
        :data="tableData"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          label="序号"
          type="index"
          width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色"
          align="center">
        </el-table-column>
         <el-table-column
          label="权限"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
            <el-button type="text"
              @click.native="goPermissionSetting(scope.row)">
              设置
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          :context="_self">
          <template slot-scope="scope">
             <el-button type="text"
              @click.native="queryUserData(scope.row)">
              查询用户
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <addorEditDialog :show.sync="addorEditDialogVisible" :title="dialogTilte"></addorEditDialog>
    <deleteDialog :show.sync="deleteDialogVisible" ></deleteDialog>
    <userDialog :show.sync="centerDialogVisible" :selectedRole='selectedRole'></userDialog>
    <pagination :size="paginations.pageSize" @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNum"></pagination>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import { queryRole } from '@/api/userAccount.js'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    addorEditDialog: () => import('./components/addorEditDialog.vue'),
    // eslint-disable-next-line vue/no-unused-components
    deleteDialog: () => import('./components/deleteDialog.vue'),
    // eslint-disable-next-line vue/no-unused-components
    userDialog: () => import('./components/userDialog.vue'),
    pagination
  },
  data () {
    return {
      centerDialogVisible: false,
      deleteDialogVisible: false,
      addorEditDialogVisible: false,
      isEdit: false,
      searchForm: {
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        count: 0,
        pageSize: 10
      },
      loadingTable: false,
      tableData: [],
      selectedRole: {}
    }
  },
  computed: {
    dialogTilte () {
      if (this.isEdit) {
        return '编辑角色'
      }
      return '新建角色'
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    handleAddorEdit () {
      this.addorEditDialogVisible = true
    },
    dateChange (value) {
      if (value !== null) {
        [this.searchForm.startTime, this.searchForm.endTime] = value
      } else {
        [this.searchForm.startTime, this.searchForm.endTime] = ['', '']
      }
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNum = page
      this.getList()
    },
    searchClick () {
      this.paginations.pageNum = 1
      this.getList()
    },
    goPermissionSetting () {
      // this.$router.push({ path: '/empManage/empManageInfoSet/permission-setting' })
    },
    queryUserData (item) {
      const { roleId } = item
      console.log('roleId: ', roleId)
      if (+roleId === 10007) {
        this.$router.push({ path: '/MerchantSetting/MerchantInfoSetting/partner-management' })
      } else {
        this.centerDialogVisible = true
        this.selectedRole = item
      }
    },
    getList () {
      this.loadingTable = true
      const params = Object.assign(this.searchForm, this.paginations)
      queryRole(params).then(response => {
        this.loadingTable = false
        if (+response.error_code === 0) {
          this.tableData = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
